import { render, staticRenderFns } from "./OrderDriverMessageManager.vue?vue&type=template&id=47204b9e&scoped=true&"
import script from "./OrderDriverMessageManager.vue?vue&type=script&lang=js&"
export * from "./OrderDriverMessageManager.vue?vue&type=script&lang=js&"
import style0 from "./OrderDriverMessageManager.vue?vue&type=style&index=0&id=47204b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47204b9e",
  null
  
)

export default component.exports